export const TRANSLATION_KEYS = {
  PANEL_TITLE: 'theme_assistant_panel_title',
  INITIAL_MESSAGE_TEXT: 'theme_assistant_initial_message_text',
  INITIAL_MESSAGE_COLORS_SUGGESTION:
    'theme_assistant_initial_message_colors_suggestion',
  INITIAL_MESSAGE_FONT_SUGGESTION:
    'theme_assistant_initial_message_font_suggestion',
  INITIAL_MESSAGE_THEME_SUGGESTION:
    'theme_assistant_initial_message_theme_suggestion',
  CHAT_PLACEHOLDER: 'theme_assistant_chat_placeholder',
  INITIAL_MESSAGE_COLORS_RESPONSE:
    'theme_assistant_initial_message_colors_response',
  INITIAL_MESSAGE_FONT_RESPONSE:
    'theme_assistant_initial_message_font_response',
  INITIAL_MESSAGE_THEME_RESPONSE:
    'theme_assistant_initial_message_theme_response',
};
